module.exports = __webpack_public_path__ + "static/NCPDP-logo-2497bc9bcc9a5d4414a89784b34abc5f.png";